export const convertAssetCurrencyToZar = (value, exchangeRate) => {
  return value * exchangeRate
}
